<script>
import { mapGetters } from 'vuex';
import CarItem from '@/components/MainFilter/CarItem';
import cookies from 'vue-cookies';
import wordEnding from '@/utils/wordEnding';
import { ref, watch } from 'vue';

export default {
  name: 'CarList',
  props: {
    cars: {
      type: Array,
      default: () => [],
    },
    page: {
      type: Number,
      default: null,
    },
    credit: {
      type: String,
    },
    numberPages: {
      type: Number,
      default: null,
    },
    countCarsCurrentCity: {
      type: Number,
      required: true,
    },
    countCarsOtherCity: {
      type: Number,
      default: null,
    },
    typePage: {
      type: String,
      required: true,
    },
    title: { type: String },
    otherCars: { type: Array },
    otherCarsTitle: { type: String },
    otherModelCars: { type: Array },
    otherModelTitle: { type: String },
    otherSoldCars: { type: Array },
    otherSoldTitle: { type: String },
    otherBrandCars: { type: Array },
    otherBrandTitle: { type: String },
    emptyCarsTitle: { type: String },
    phpRender: { type: Boolean },
    stock: {
      type: String,
      default: null,
    },
    isLanding: {
      type: Boolean,
      default: false,
    },
    perPage: {
      type: Number,
      default: null,
    },
    autoOrderUrl: {
      type: String,
      default: '',
    },
  },
  components: {
    CarItem,
  },
  setup(props) {
    const visibleCount = ref(24);
    let visibleItems = ref([]);
    let itemsLength;
    if (props.otherCars && props.otherCars.length > 0) {
      visibleItems = ref(props.otherCars.slice(0, visibleCount.value));
      itemsLength = props.otherCars.length;
    }
    // if (props.otherModelCars && props.otherModelCars.length > 0) {
    //   visibleItems = ref(props.otherModelCars.slice(0, visibleCount.value));
    //   itemsLength = props.otherModelCars.length;
    // }

    const loadMore = () => {
      visibleCount.value = Math.min(
        visibleCount.value + props.perPage,
        itemsLength,
      );
    };

    watch(visibleCount, newCount => {
      visibleItems.value = props.otherCars.slice(0, newCount);
    });

    return {
      visibleItems,
      visibleCount,
      loadMore,
    };
  },
  cookies,
  wordEnding,
  data() {
    return {
      currentCars: this.cars,
      currentPage: 1,
      currentLastPage: this.numberPages,
      isCloseBanner: false,
      currentCountCityCars: this.countCarsCurrentCity,
      currentCountOtherCars: this.countCarsOtherCity,
      credit: this.credit,
    };
  },
  watch: {
    credit(val) {
      this.credit = val;
    },
    filterCars() {
      if (this.currentPage === 1) {
        this.currentCars = this.filterCars;
      } else {
        this.currentCars = this.currentCars.concat(this.filterCars);
      }
    },
    page() {
      this.currentPage = this.page;
    },
    countCityCars() {
      this.currentCountCityCars = this.countCityCars;
    },
    countOtherCars() {
      this.currentCountOtherCars = this.countOtherCars;
    },
    lastPage() {
      this.currentLastPage = this.lastPage;
    },
  },
  computed: {
    ...mapGetters({
      filterCars: 'Filter/filterCars',
      countCityCars: 'Filter/countCityCars',
      countOtherCars: 'Filter/countOtherCars',
      lastPage: 'Filter/lastPage',
    }),
    bannerTitle() {
      return this.emptyCarsTitle;
    },
    linkToFilterWithRussia() {
      let type = '';
      const pathName = window.location.pathname
        .trim()
        .split('/')
        .slice(2)
        .join('/');
      if (!this.isLanding) {
        if (this.typePage === 'used') {
          type = `${pathName}`;
        } else {
          type = `cars/${this.typePage}/`;
        }
      }

      return `${document.location.origin}/${type}`;
    },
    numberGridColumns() {
      let number = 1;

      if (window.matchMedia('(min-width: 1280px)')) {
        number = 3;
      } else if (window.matchMedia('(min-width: 640px)')) {
        number = 2;
      }
      return number;
    },
  },
  methods: {
    showMore() {
      this.currentPage = this.currentPage + 1;
      this.$emit('change-page', this.currentPage);
    },
    closeBanner() {
      this.isCloseBanner = true;
    },
    changeAjax() {
      this.$emit('allow-ajax', true);
    },
  },
  mounted() {
    setTimeout(() => {
      this.changeAjax();
    }, 1000);
  },
};
</script>

<template>
  <div>
    <div
      v-if="currentCars?.length > 0"
      id="car-list"
      class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5"
      :class="{ 'xl:grid-cols-4': typePage === 'used' }"
    >
      <template v-for="(car, index) in currentCars" :key="index">
        <car-item
          v-if="car.current_city"
          :car="car"
          :key="index"
          :credit="credit"
          :typePage="typePage"
        ></car-item>

        <car-item
          v-if="!car.current_city"
          :car="car"
          :key="index"
          :typePage="typePage"
        ></car-item>
      </template>

      <button
        v-if="currentPage + 1 <= currentLastPage"
        class="button button_white button_big w-full h-16 rounded-big-brand col-start-1 sm:col-end-3 mt-1 2xl:mt-3"
        :class="{
          'xl:col-end-5': typePage === 'used',
          'xl:col-end-4': typePage !== 'used',
        }"
        @click="showMore"
      >
        Показать еще
      </button>
    </div>
    <div
      v-if="
        (otherCars?.length > 0 && phpRender) ||
        (currentCars?.length > 0 && otherCars?.length > 0 && phpRender) ||
        (otherModelCars?.length > 0 &&
          !currentCars?.length &&
          !otherCars?.length &&
          phpRender)
      "
      class="flex px-[23px] py-[20px] bg-gray-200 rounded-brand my-[32px]"
    >
      <img
        src="/public/images/svg/attent.svg"
        alt="attention"
        width="39"
        height="39"
      />
      <div class="flex flex-col ml-[10px] gap-[6px] self-center">
        <div v-if="!currentCars.length" class="font-medium">
          {{ bannerTitle }}
        </div>
        <div v-if="otherCars?.length && typePage !== 'stock'">
          {{ otherCarsTitle }}
        </div>
        <div v-if="visibleItems?.length && typePage === 'stock'">
          {{ otherCarsTitle }}
        </div>
      </div>
    </div>
    <div
      v-if="
        otherCars && otherCars?.length > 0 && phpRender && typePage !== 'stock'
      "
    >
      <div
        id="car-list"
        class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5"
        :class="{ 'xl:grid-cols-4': typePage === 'used' }"
      >
        <template v-for="(car, index) in otherCars" :key="index">
          <car-item :car="car" :typePage="typePage"></car-item>
        </template>
      </div>
    </div>
    <div v-if="visibleItems && phpRender && typePage !== 'used'">
      <div
        id="car-list"
        class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5"
        :class="{ 'xl:grid-cols-4': typePage === 'used' }"
      >
        <template v-for="(car, index) in visibleItems" :key="index">
          <car-item :car="car" :typePage="typePage"></car-item>
        </template>
        <button
          class="button button_white button_big w-full h-16 rounded-big-brand col-start-1 sm:col-end-3 mt-1 2xl:mt-3"
          v-if="otherCars && visibleCount < otherCars.length"
          :class="{
            'xl:col-end-5': typePage === 'used',
            'xl:col-end-4': typePage !== 'used',
          }"
          @click="loadMore"
        >
          Показать еще
        </button>
        <button
          class="button button_white button_big w-full h-16 rounded-big-brand col-start-1 sm:col-end-3 mt-1 2xl:mt-3"
          v-if="otherModelCars && visibleCount < otherModelCars.length"
          :class="{
            'xl:col-end-5': typePage === 'used',
            'xl:col-end-4': typePage !== 'used',
          }"
          @click="loadMore"
        >
          Показать еще
        </button>
      </div>
    </div>
    <div
      v-if="
        otherModelCars &&
        otherModelCars.length &&
        phpRender &&
        typePage !== 'used'
      "
    >
      <h3 class="title-h3 my-[32px]">
        {{ otherModelTitle }}
      </h3>
      <div
        id="car-list"
        class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5"
        :class="{ 'xl:grid-cols-4': typePage === 'used' }"
      >
        <template v-for="(car, index) in otherModelCars" :key="index">
          <car-item :car="car" :typePage="typePage"></car-item>
        </template>
        <button
          class="button button_white button_big w-full h-16 rounded-big-brand col-start-1 sm:col-end-3 mt-1 2xl:mt-3"
          v-if="otherCars && visibleCount < otherCars.length"
          :class="{
            'xl:col-end-5': typePage === 'used',
            'xl:col-end-4': typePage !== 'used',
          }"
          @click="loadMore"
        >
          Показать еще
        </button>
        <button
          class="button button_white button_big w-full h-16 rounded-big-brand col-start-1 sm:col-end-3 mt-1 2xl:mt-3"
          v-if="otherModelCars && visibleCount < otherModelCars.length"
          :class="{
            'xl:col-end-5': typePage === 'used',
            'xl:col-end-4': typePage !== 'used',
          }"
          @click="loadMore"
        >
          Показать еще
        </button>
      </div>
    </div>
    <div
      v-if="
        otherModelCars &&
        otherModelCars.length > 0 &&
        phpRender &&
        typePage !== 'stock'
      "
    >
      <h3 class="title-h3 my-[32px]">
        {{ otherModelTitle }}
      </h3>
      <div
        id="car-list"
        class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5"
        :class="{ 'xl:grid-cols-4': typePage === 'used' }"
      >
        <template v-for="(car, index) in otherModelCars" :key="index">
          <car-item :car="car" :typePage="typePage"></car-item>
        </template>
      </div>
    </div>
    <div v-if="otherBrandCars && otherBrandCars.length > 0 && phpRender">
      <h3 class="title-h3 my-[32px]">
        {{ otherBrandTitle }}
      </h3>
      <div
        id="car-list"
        class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5"
        :class="{ 'xl:grid-cols-4': typePage === 'used' }"
      >
        <template v-for="(car, index) in otherBrandCars" :key="index">
          <car-item :car="car" :typePage="typePage"></car-item>
        </template>
      </div>
    </div>
    <div v-if="otherSoldCars && otherSoldCars.length > 0 && phpRender">
      <h3 class="title-h3 my-[32px]">
        {{ otherSoldTitle }}
      </h3>
      <div
        id="car-list"
        class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5"
        :class="{ 'xl:grid-cols-4': typePage === 'used' }"
      >
        <template v-for="(car, index) in otherSoldCars" :key="index">
          <car-item :car="car" :typePage="typePage"></car-item>
        </template>
      </div>
    </div>
    <div v-if="!currentCars?.length && !phpRender" class="text-center">
      Ой, по данным фильтрам сейчас нет автомобилей в наличии.<br />
      ЗАТО ИМЕННО ТАКОЙ АВТОМОБИЛЬ МЫ МОЖЕМ ПРИВЕЗТИ! Узнайте подробнее здесь
      <!-- <a
        :href="autoOrderUrl"
        class="button button_green button_small flex items-center w-fit mx-auto mt-4"
        >Авто на заказ</a
      > -->
    </div>
  </div>
</template>
